import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './styles/style.css'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import { apiConfig } from './core/apiConfig'

createApp(App).use(store).use(router).use(VueGoogleMaps, {
  load: {
    key: apiConfig.googleApiKey
  }
}).mount('#app')
